import { DomainStore } from './DomainStore';

export default DomainStore;
